export enum OnboardingStatus {
  finished = 'FINISHED',
  step0 = 'STEP_0',
  step1 = 'STEP_1',
  step2 = 'STEP_2',
  step3 = 'STEP_3',
  step4 = 'STEP_4',
}
